import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { holidaysSaga , addholidays, deleteHolidaysSaga } from './NotificationSettingSaga';

export function* notificationSettingSaga() {
  yield takeLatest(sagaActions.GET_HOLIDAYS_DETAILS, holidaysSaga);
  yield takeLatest(sagaActions.ADD_HOLIDAYS_DETAILS, addholidays);
  yield takeLatest(sagaActions.DELETE_HOLIDAYS_DETAILS, deleteHolidaysSaga);
}
